const TTL_DAYS = 2;
const TTL_MILLISECONDS = TTL_DAYS * 24 * 60 * 60 * 1000;

export const saveWithTTL = (key, data) => {
    const timestamp = Date.now();
    const dataToStore = {
        data: data,
        timestamp: timestamp,
    };
    try {
        localStorage.setItem(key, JSON.stringify(dataToStore));
    } catch (e) {
        console.error(`Error saving data for key "${key}" to localStorage:`, e);
    }
};

export const getWithTTL = (key) => {
    try {
        const storedData = localStorage.getItem(key);
        if (!storedData) {
            return {};
        }

        const parsedData = JSON.parse(storedData);
        if (!parsedData || parsedData.data === undefined || parsedData.timestamp === undefined) {
             localStorage.removeItem(key);
             return {};
        }
        
        const { data, timestamp } = parsedData;
        const now = Date.now();

        if (now - timestamp > TTL_MILLISECONDS) {
            localStorage.removeItem(key);
            return {};
        }

        return data;

    } catch (e) {
        console.error(`Error retrieving or parsing data for key "${key}" from localStorage:`, e);
        localStorage.removeItem(key);
        return {};
    }
};